import { ExclamationCircleOutlined } from '@ant-design/icons';
import { notification } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { ButtonSecondary } from '../../../../../components/Button/styles';
import { getDadosCalculoFreteSeparado } from '../../../../../helpers/calculaValoresLote';
import { useBoolean } from '../../../../../hooks/useBoolean';
import apiShipper from '../../../../../services/apiShipper';
import colors from '../../../../../styles/colors';
import TipoAlteracaoEnum from '../../../Enum/TipoAlteracaoEnum';
import AlterarFreteModal from './AlterarFreteModal';
import FinalizarModal from './FinalizarModal';
import RetomarModal from './RetomarModal';
import { Container, Spin } from './styles';
import SuspenderModal from './SuspenderModal';

const Actions = ({ idDemanda, dadosAcoesEmMassa }) => {
  const { value: frete, toggle: toggleFrete } = useBoolean(false);
  const { value: suspender, toggle: toggleSuspender } = useBoolean(false);
  const { value: retomar, toggle: toggleRetormar } = useBoolean(false);
  const { value: finalizar, toggle: toggleFinalizar } = useBoolean(false);
  const [agendamentoSuspender, setAgendamentoSuspender] = useState({
    id: null,
    data: null,
    justificativa: null,
  });
  const [agendamentoRetomar, setAgendamentoRetomar] = useState({
    id: null,
    data: null,
  });
  const [agendamentoFinalizar, setAgendamentoFinalizar] = useState({
    id: null,
    data: null,
  });
  const [agendamentoAlterarFrete, setAgendamentoAlterarFrete] = useState({
    id: null,
    data: null,
    freteEmpresa: null,
  });
  const [tarifaTmovClienteLista, setTarifaTmovClienteLista] = useState(0);
  const [valorPedagio, setValorPedagio] = useState(0);
  const [loading, setLoading] = useState(false);
  const {
    cliente_razao_social,
    origem,
    destino,
    email_filiais,
    endereco,
    dadosPagador,
    validacaoStatusLote,
    tipo_pagamento,
  } = dadosAcoesEmMassa;

  const actionPayload = {
    id_demanda: Number(idDemanda),
    cliente_razao_social,
    origem,
    destino,
    email_filiais,
    tipo_pagamento,
  };

  const Exclamation = () => (
    <ExclamationCircleOutlined style={{ color: colors.$auxiliary_yolk_5 }} />
  );

  useEffect(() => {
    (async () => {
      const { data } = await apiShipper.get('alteracao-demanda', {
        params: {
          id_demanda: idDemanda,
        },
      });

      if (!data) return;

      const agendamentoSupensao = data.find(
        agendamento =>
          agendamento.tipo_alteracao === TipoAlteracaoEnum.SUSPENDER
      );

      const agendamentoRetomada = data.find(
        agendamento => agendamento.tipo_alteracao === TipoAlteracaoEnum.RETOMAR
      );

      const agendamentoFinalizacao = data.find(
        agendamento =>
          agendamento.tipo_alteracao === TipoAlteracaoEnum.FINALIZAR
      );

      const agendamentoAlteracaoFrete = data.find(
        agendamento =>
          agendamento.tipo_alteracao === TipoAlteracaoEnum.FRETE_EMPRESA
      );

      if (agendamentoSupensao) {
        setAgendamentoSuspender({
          id: agendamentoSupensao.id,
          data: agendamentoSupensao.data_alteracao,
          justificativa: agendamentoSupensao.motivo_suspensao,
        });
      }

      if (agendamentoRetomada) {
        setAgendamentoRetomar({
          id: agendamentoRetomada.id,
          data: agendamentoRetomada.data_alteracao,
        });
      }

      if (agendamentoFinalizacao) {
        setAgendamentoFinalizar({
          id: agendamentoFinalizacao.id,
          data: agendamentoFinalizacao.data_alteracao,
        });
      }

      if (agendamentoAlteracaoFrete) {
        setAgendamentoAlterarFrete({
          id: agendamentoAlteracaoFrete.id,
          data: agendamentoAlteracaoFrete.data_alteracao,
          freteEmpresa: agendamentoAlteracaoFrete.frete_empresa,
        });
      }
    })();
  }, [idDemanda]);

  useEffect(() => {
    const onInitCarregarDadosTarifa = async () => {
      try {
        setLoading(true);
        if (!endereco || !dadosPagador?.id_cliente_raiz) return;

        const {
          pedagioCalculado,
          tarifaTmovCliente,
        } = await getDadosCalculoFreteSeparado(
          endereco,
          dadosPagador.id_cliente_raiz
        );

        setValorPedagio(pedagioCalculado);
        setTarifaTmovClienteLista(tarifaTmovCliente);
      } catch (error) {
        notification.error({
          message:
            'Ops, não foi possível recuperar valores para calcular frete',
          description:
            'Por favor, entre em contato com nosso suporte caso o problema persistir.',
        });
      } finally {
        setLoading(false);
      }
    };

    onInitCarregarDadosTarifa();
  }, [endereco, dadosPagador.id_cliente_raiz]);

  return (
    <Container>
      {loading ? (
        <Spin />
      ) : (
        <>
          <AlterarFreteModal
            visible={frete}
            setVisible={() => toggleFrete()}
            agendamento={agendamentoAlterarFrete}
            setAgendamento={setAgendamentoAlterarFrete}
            actionPayload={actionPayload}
            valorPedagio={valorPedagio}
            tarifaTmovClienteLista={tarifaTmovClienteLista}
          />
          <SuspenderModal
            visible={suspender}
            setVisible={() => toggleSuspender()}
            agendamento={agendamentoSuspender}
            setAgendamento={setAgendamentoSuspender}
            actionPayload={actionPayload}
          />
          <RetomarModal
            visible={retomar}
            setVisible={() => toggleRetormar()}
            agendamento={agendamentoRetomar}
            setAgendamento={setAgendamentoRetomar}
            actionPayload={actionPayload}
          />
          <FinalizarModal
            visible={finalizar}
            setVisible={() => toggleFinalizar()}
            agendamento={agendamentoFinalizar}
            setAgendamento={setAgendamentoFinalizar}
            actionPayload={actionPayload}
          />

          <p>
            <b>Ações:</b>
          </p>
          <ButtonSecondary
            onClick={toggleFrete}
            disabled={validacaoStatusLote.isFinalizado}
          >
            Alterar frete empresa
            {agendamentoAlterarFrete.data && Exclamation()}
          </ButtonSecondary>

          <ButtonSecondary
            onClick={toggleSuspender}
            disabled={
              validacaoStatusLote.isSuspenso || validacaoStatusLote.isFinalizado
            }
          >
            Suspender todos
            {agendamentoSuspender.data && Exclamation()}
          </ButtonSecondary>

          <ButtonSecondary
            onClick={toggleRetormar}
            disabled={
              validacaoStatusLote.isCarregando ||
              validacaoStatusLote.isFinalizado
            }
          >
            Retomar lotes suspensos
            {agendamentoRetomar.data && Exclamation()}
          </ButtonSecondary>

          <ButtonSecondary
            onClick={toggleFinalizar}
            disabled={validacaoStatusLote.isFinalizado}
          >
            Finalizar todos
            {agendamentoFinalizar.data && Exclamation()}
          </ButtonSecondary>
        </>
      )}
    </Container>
  );
};

Actions.propTypes = {
  idDemanda: PropTypes.number,
  dadosAcoesEmMassa: PropTypes.shape({
    cliente_razao_social: PropTypes.string,
    origem: PropTypes.string,
    destino: PropTypes.string,
    email_filiais: PropTypes.arrayOf(PropTypes.string),
    endereco: PropTypes.objectOf(PropTypes.any),
    dadosPagador: PropTypes.objectOf(PropTypes.any).isRequired,
    validacaoStatusLote: PropTypes.shape({
      isCarregando: PropTypes.bool,
      isSuspenso: PropTypes.bool,
      isFinalizado: PropTypes.bool,
    }).isRequired,
    tipo_pagamento: PropTypes.string,
  }),
};

Actions.defaultProps = {
  idDemanda: 0,
  dadosAcoesEmMassa: {
    cliente_razao_social: '',
    origem: '',
    destino: '',
    email_filiais: [],
    endereco: [],
    dadosPagador: [],
  },
};

export default Actions;
